module.exports = __webpack_public_path__ + "static/media/icono-hellmanns-uy-compradores.5a62bdf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-hellmanns-uy-compradores.png
// module id = 300
// module chunks = 0